import { ReactNode } from "react";
import { Grid } from "@mui/material";
import { IntegrationToggleOption } from "~/pages/integrations/components/toggle-option/IntegrationToggleOption";
import { Control } from "react-hook-form/dist/types/form";
import { JiraFormInput } from "./JiraIntegrationForm/JiraIntegrationForm";
import { ZendeskFormInput } from "~/pages/integrations/hosted-integrations/forms/zendesk/ZendeskIntegrationForm";
import { GithubIssueFormInput } from "~/pages/integrations/hosted-integrations/forms/github-issues/GithubIssuesIntegrationForm";
import { GitlabIssueFormInput } from "~/pages/integrations/hosted-integrations/forms/gitlab-issues/GitlabIssuesIntegrationForm";
import { AzureDevOpsFormInput } from "~/pages/integrations/hosted-integrations/forms/azure-devops/AzureDevOpsIntegrationForm";
import { WebhookFormInput } from "~/pages/integrations/hosted-integrations/forms/webhook/WebhookIntegrationForm";
import { ticketingSystemName } from "./utils/jiraIntegrationUtils";
import { ticketingIntegrationTypes } from "~/pages/integrations/utils/integrationConstants";
import { ServiceNowFormInput } from "../servicenow/ServiceNowIntegrationForm/ServiceNowIntegrationForm";

interface JiraAutoConfigurationSectionProps {
  ticketType: (typeof ticketingIntegrationTypes)[number];
  control:
    | Control<JiraFormInput>
    | Control<ZendeskFormInput>
    | Control<GithubIssueFormInput>
    | Control<GitlabIssueFormInput>
    | Control<AzureDevOpsFormInput>
    | Control<WebhookFormInput>
    | Control<ServiceNowFormInput>;

  autoCreateSubField?: ReactNode;
  showAutoCreateSection: boolean;
}

export const JiraAutoConfigurationSection = ({
  ticketType,
  control,
  autoCreateSubField,
  showAutoCreateSection,
}: JiraAutoConfigurationSectionProps) => {
  return (
    <>
      <Grid size={12}>
        <IntegrationToggleOption
          title="Automatically close issues"
          description={`If you create a ticket in Mondoo and then resolve it, the corresponding ${ticketingSystemName(
            ticketType,
          )} issue closes.`}
          formOptions={{
            name: "autoCloseTickets",
            control,
          }}
        />
      </Grid>
      {showAutoCreateSection && (
        <Grid mt={3} size={12}>
          <IntegrationToggleOption
            title="Create drift issues in this integration"
            description="If 'Automatically create tickets on drift' is enabled in space settings, create an issue in this integration for each new drift ticket. "
            formOptions={{
              name: "autoCreateTickets",
              control,
            }}
          />
          {autoCreateSubField}
        </Grid>
      )}
    </>
  );
};
